import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../BusinessConsulting.css";
import Services from "../Pages/Services";
import WhyWorkWithUs from "../Pages/WhyWorkWithUs";

const WebDevelopment = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: "0px 0px -50px 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-visible");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll(".animate-on-scroll");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // Add this effect for additional hover effects
  useEffect(() => {
    // Add hover effect for list items
    const listItems = document.querySelectorAll(".list-style-one li");
    listItems.forEach((item) => {
      item.addEventListener("mouseenter", (e) => {
        e.currentTarget.style.transform = "translateX(8px)";
        e.currentTarget.style.color = "#0d6efd";
      });
      item.addEventListener("mouseleave", (e) => {
        e.currentTarget.style.transform = "translateX(0)";
        e.currentTarget.style.color = "";
      });
    });

    return () => {
      listItems.forEach((item) => {
        item.removeEventListener("mouseenter", () => {});
        item.removeEventListener("mouseleave", () => {});
      });
    };
  }, []);

  return (
    <>
      <style>
        {`
          /* Enhanced Animations */
          .animate-on-scroll {
            opacity: 0;
            transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
          }

          .fade-in-left {
            transform: translateX(-50px);
          }

          .fade-in-right {
            transform: translateX(50px);
          }

          .animate-visible {
            opacity: 1 !important;
            transform: translateX(0) !important;
          }

          /* Attractive Image Styles */
          .hover-scale {
            transition: all 0.4s ease;
            cursor: pointer;
            position: relative;
            overflow: hidden;
          }

          .hover-scale:hover {
            transform: scale(1.05) rotate(1deg);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
          }

          /* Attractive List Styles */
          .list-style-one {
            list-style: none;
            padding-left: 0;
          }

          .list-style-one li {
            position: relative;
            padding: 8px 0 8px 30px;
            margin-bottom: 8px;
            background: linear-gradient(90deg, #f8f9fa 0%, transparent 100%);
            border-radius: 8px;
            transition: all 0.3s ease;
            font-weight: 500;
            cursor: pointer;
          }

          .list-style-one li::before {
            content: "✨";
            position: absolute;
            left: 8px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 16px;
            transition: transform 0.3s ease;
          }

          .list-style-one li:hover::before {
            transform: translateY(-50%) scale(1.2);
          }

          /* Section Card Effects */
          .section-card {
            border-radius: 15px;
            transition: all 0.3s ease;
          }

          .section-card:hover {
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          }

          /* Attractive Headings */
          // .fw-bold {
          //   position: relative;
          //   display: inline-block;
          //   margin-bottom: 20px;
          //   font-size: 2rem;
          //   background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          //   -webkit-background-clip: text;
          //   -webkit-text-fill-color: transparent;
          //   background-clip: text;
          // }

          // .fw-bold::after {
          //   content: '';
          //   position: absolute;
          //   bottom: -8px;
          //   left: 0;
          //   width: 60px;
          //   height: 3px;
          //   background: linear-gradient(90deg, #0d6efd, #00d4ff);
          //   border-radius: 3px;
          //   transition: width 0.3s ease;
          // }

          // .fw-bold:hover::after {
          //   width: 100px;
          // }

          /* Image Container Effects */
          .img-container {
            position: relative;
            border-radius: 15px;
            overflow: hidden;
          }

          .img-container::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(45deg, rgba(13,110,253,0.1), rgba(0,212,255,0.1));
            opacity: 0;
            transition: opacity 0.3s ease;
            z-index: 1;
            pointer-events: none;
          }

          .img-container:hover::before {
            opacity: 1;
          }

          /* Enhanced Shadow */
          .shadow {
            box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.15) !important;
            transition: all 0.3s ease;
          }

          .shadow:hover {
            box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.25) !important;
          }

          /* Responsive Adjustments */
          @media (max-width: 768px) {
            .fw-bold {
              font-size: 1.5rem;
            }
            
            .list-style-one li {
              padding: 6px 0 6px 25px;
              font-size: 14px;
            }
          }
        `}
      </style>

      <div
        className="container-fluid p-0 banner-section"
        style={{ backgroundImage: "url('img/erp.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="row">
          <div className="col-md-12 mt-5 text-white text-center">
            <h1 className="pt-5 mt-5">Web Development</h1>
            <nav>
              <ol className="breadcrumb justify-content-center bg-transparent">
                <li className="breadcrumb-item">
                  <Link to="/" className="text-white text-decoration-none">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Web Development
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className="container mb-1 mt-4 py-1">
        <div className="row pt-3 align-items-center">
          <div className="col-md-6 animate-on-scroll fade-in-left">
            <div className="img-container">
              <img
                src="img/bc.webp"
                alt="Process Assessment"
                className="img-fluid rounded shadow hover-scale"
              />
            </div>
          </div>

          <div className="col-md-6 animate-on-scroll fade-in-right">
            <h1 className="fw-bold">Web Development Services</h1>
            <p className="py-0" style={{ fontSize: "18px", lineHeight: "1.6" }}>
              At DigiOpen Services, we create modern, scalable, and
              high-performing web solutions that help businesses establish a
              strong digital presence and achieve their strategic goals. Our web
              development services combine innovative design, robust technology,
              and user-centric functionality to deliver websites and web
              applications that drive engagement, improve operational
              efficiency, and support business growth.
            </p>
            <p className="py-0" style={{ fontSize: "18px", lineHeight: "1.6" }}>
              Whether you need a corporate website, e-commerce platform,
              customer portal, or a custom web application, our experienced
              development team delivers solutions tailored to your unique
              business requirements.
            </p>
            <p className="py-1" style={{ fontSize: "18px", lineHeight: "1.6" }}>
              We are committed to delivering web solutions that not only
              strengthen your online presence but also create measurable
              business value. Our goal is to help organizations leverage digital
              technologies to improve customer engagement, streamline
              operations, and achieve sustainable growth in an increasingly
              competitive marketplace.
            </p>
          </div>
        </div>
      </div>

      <div className="animate-on-scroll fade-in-up">
        <WhyWorkWithUs />
      </div>

      {/* SECTION 1 - Android Development Expertise */}
      <div className="container mb-5 mt-3 py-4 section-card">
        <div className="row align-items-center">
          <div className="col-md-6 order-md-1 order-2 animate-on-scroll fade-in-left">
            <h3 className="fw-bold mb-4">Our Web Development Services</h3>
            <ul className="list-style-one d-flex flex-wrap">
              <li className="col-12 mb-2">
              Custom Website Development
              </li>
              <li className="col-12 mb-2">Enterprise Web Applications</li>
              <li className="col-12 mb-2">E-Commerce Solutions</li>
              <li className="col-12 mb-2">Customer and Employee Portals</li>
              <li className="col-12 mb-2">Responsive and Mobile-Friendly Design</li>
              <li className="col-12 mb-2">
                Content Management System (CMS) Development
              </li>
              <li className="col-12 mb-2">
              API Integration and Third-Party System Connectivity
              </li>
              <li className="col-12 mb-2">
               Website Maintenance and Performance Optimization
              </li>
            </ul>
          </div>

          <div className="col-md-6 mb-4 mb-md-0 order-md-2 order-1 animate-on-scroll fade-in-right">
            <div className="img-container">
              <img
                src="img/about1.jpg"
                alt="Android Development Expertise"
                className="img-fluid rounded shadow hover-scale"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 2 - Our Development Approach */}
      <div className="container mb-5 mt-3 py-4 section-card">
        <div className="row align-items-center">
          <div className="col-md-6 mb-4 mb-md-0 order-1 order-md-1 animate-on-scroll fade-in-left">
            <div className="img-container">
              <img
                src="img/services1.jpg"
                alt="Development Approach"
                className="img-fluid rounded shadow hover-scale"
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <div className="col-md-6 order-2 order-md-2 animate-on-scroll fade-in-right">
            <h3 className="fw-bold mb-4">Our Development Approach</h3>
            <ul className="list-style-one d-flex flex-wrap">
              <li className="col-12 mb-2">
                 Understanding business goals and user requirements
              </li>
              <li className="col-12 mb-2">
                 Designing intuitive and engaging user experiences
              </li>
              <li className="col-12 mb-2">
                 Developing secure, scalable, and high-performance solutions
              </li>
              <li className="col-12 mb-2">
                 Content Management System (CMS) Development
              </li>
              <li className="col-12 mb-2">
                 Deploying applications efficiently and reliably
              </li>
              <li className="col-12 mb-2">
                 Providing continuous support and enhancement services
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebDevelopment;